import React from "react";
import { useHistory } from "react-router-dom";
import btnStyles from "../styles/Button.module.css";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styles from "../styles/Account.module.css";

export default function PrivacyPolicy() {
  const history = useHistory();

  return <>
  <div className="px-3">
  <h3 className="text-center py-4 w-100 mt-2"
        style={{
          // background: "#3B444A",
          background: "#39606e",
          color: "#F5F5F5",
          // fontFamily: "Playfair Display",
          textTransform: "uppercase",
        }}
      >
        Privacy Policy
  </h3>
  {/* back button */}
  <Row className="mt-1">
    <Col xs={6} className="">
    <Button
        className={`${btnStyles.Button} ${btnStyles.Blue}`}
        onClick={() => history.goBack()}
      >
        Back
    </Button>
    </Col>
  </Row>
  <Row className="mt-1">
  <Col md={{span: 10, offset: 1}} className="mb-5">
  <h5 className="mt-5">
   FirstSlate respects your privacy and is committed to protecting 
   your information ("<span className={`${styles.Bold}`}>Personal Data</span>"). This 
   privacy notice will inform you as to how we look after your personal data when 
   you visit the websites (the “<span className={`${styles.Bold}`}>Websites</span>”) (regardless 
   of where you visit it from) including any data that you provide about 
   using our services and tell you about your privacy rights and how the law protects you.
  </h5>
  <h5 className="mt-3">
    This privacy policy (the "<span className={`${styles.Bold} mb-0`}>Policy</span>") gives 
    you information about how FirstSlate collects and uses your personal data 
    through the use of the Websites, including any data you may provide when 
    you use the Production Software.
  </h5>
  <h5 className="mt-3">
    The “<span className={`${styles.Bold} mb-0`}></span>Websites” 
    are operated by [FirstSlate Limited], incorporated under the laws of 
    Ireland (CRO. Registered number [817238]), with registered 
    address [FirstSlate Limited, 5 Monkton Row, Wicklow, Wicklow A67VK02
Ireland] (“<span className={`${styles.Bold} mb-0`}>FirstSlate</span>”,
     “<span className={`${styles.Bold} mb-0`}>us</span>”,
      “<span className={`${styles.Bold} mb-0`}>we</span>” and
       “<span className={`${styles.Bold} mb-0`}>our</span>”). The Websites operated by FirstSlate consist of:  
  </h5>
  <h5 className="mt-3 pl-5">
    <span className={`${styles.Bold} mb-0`}>i.</span>	the website containing software for production 
    managers (“<span className={`${styles.Bold} mb-0`}>Primary User</span>”) for 
    the administration and budgeting of production 
    projects (“<span className={`${styles.Bold} mb-0`}>FirstSlate</span>”); 
  </h5>
  <h5 className="mt-3 pl-5">
    <span className={`${styles.Bold} mb-0`}>ii.</span>	the website containing software to be used by cast, 
    crew (“<span className={`${styles.Bold} mb-0`}>Crew Users</span>”) and 
    Primary Users for, among other things, planning, designing, scheduling, 
    preparing and issuing call sheets, crew administration and collaborating with others
    for production (“<span className={`${styles.Bold} mb-0`}>FirstSlate</span>”). 
    Crew Users shall be designated and registered by production administrative 
    personnel (“<span className={`${styles.Bold} mb-0`}>Administrative Users</span>”), who 
    in turn are designated and registered by the Primary User.
  </h5>
  <h5 className="mt-3 pl-5"> 
  (together the “<span className={`${styles.Bold} mb-0`}>Production Software</span>”)
  </h5>
  <h5 className="mt-3">
    FirstSlate uses your information in line with the Data Protection Acts 1988 to 2018, 
    the General Data Protection Regulation (EU) 2016/679 (“GDPR”), and any other 
    applicable law or regulation relating to the processing of Personal Data and 
    to privacy (including the E-Privacy Directive 2002/58/EC and the European 
    Communities (Electronic Communications Networks and Services) (Privacy and 
    Electronic Communications) Regulations 2011, as such legislation shall be 
    supplemented, amended, revised or replaced from time to 
    time ("<span className={`${styles.Bold} mb-0`}>Data Protection Laws</span>"). 
  </h5>
  <h5 className="mt-3">
   The Policy sets out the basis on which we use, process, store or disclose any 
   Personal Data detailed below that we collect 
   from you or that you provide to us through the Website. 
  </h5>
  <h5 className="mt-3">
   We do not act as a Data Controller in relation to personal data of an 
   Administrative User or Crew User, collected or processed by another User, 
   in the course of designating and registering Users in accordance with paragraph 
   1 above. However, we act as a Data Controller to the extent Personal Data of an 
   Administrative User or Crew User is collected or processed during their use of 
   FirstSlate. 
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>
    1.	OVERVIEW OF THIS POLICY
   </span>
  </h3>
  <h5 className="mt-3">
   <span className={`${styles.Bold} mb-0`}>THE PERSONAL DATA WE PROCESS</span>
  </h5>
  <h5 className="mt-3">
    We fully respect your right to privacy in relation to your interactions with the 
    Website and our Services and we strive to be transparent in our dealings with you 
    as to what information we will collect and how we will use your information. 
    Also, we only collect and use individual’s information where we are legally 
    entitled to do so. Information in relation to your rights in respect of 
    Personal Data collected by Irish entities is available on www.dataprotection.ie, 
    the website of the Irish Data Protection Commission (“<span className={`${styles.Bold} mb-0`}>DPC</span>”).
  </h5>
  <h5 className="mt-3">
    We <span className={`${styles.Bold} mb-0`}>collect and process</span> the 
    following Personal Data from you: 
  </h5>

  <div className="mt-3">
  <Row>
  <Col xs={4} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3 mb-0`}>
      Device Information
    </p>
    </Col>
    <Col xs={8} className={`${styles.ChartBor }`}>
    <p className={` mb-0`}>
    When using the Website and availing of the Production Software, 
    personal information is collected from you by FirstSlate, which may 
    include information about your device browser including your IP address.
    </p>
    </Col>
  </Row>
  </div>
  <div>
  <Row>
  <Col xs={4} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3 mb-0`}>
      Registration Information
    </p>
    </Col>
    <Col xs={8} className={`${styles.ChartBor }`}>
    <p className={` mb-0`}>
    Upon registering as a Primary User, you will be asked for basic information, 
    which may include your name, email address, contact number and bank details.  
    </p>
    </Col>
  </Row>
  </div>
  <h5 className="mt-5">
    You <span className={`${styles.Bold} mb-0`}>can choose to provide us</span> with the following Personal Data:
  </h5>
  <div className="mt-3">
  <Row>
  <Col xs={4} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3 mb-0`}>
      Production Information
    </p>
    </Col>
    <Col xs={8} className={`${styles.ChartBor }`}>
    <p className={` mb-0`}>
    You may choose to give us additional information such as your address, 
    phone number, job title, role in the production, photographs, videos, 
    sketches and/or production notes.   
    </p>
    </Col>
  </Row>
  </div>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>2.	HOW AND WHY WE USE YOUR PERSONAL DATA</span>
  </h3>
  <h5 className="mt-3">
    The following table details the legal 
    bases and the purposes for which we process your Personal Data:
  </h5>
  <div className="mt-3">
  <Row>
  <Col xs={8} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3 mb-5`}>
      LEGAL BASES & PURPOSES
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3 mb-0`}>
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={4} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3 mb-5`}>
      Legal Basis
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3 mb-5`}>
      Purpose(s)
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3 mb-5`}>
      Personal Data Processed
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Contract
    </p>
    <p className={` pl-3`}>
      It is necessary to process the Personal Data to enter into and perform 
      our contract with you regarding your use of the Website and Production 
      Software as set out in the Terms of Service.
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Access to the Production Software
    </p>
    <p className={` pl-3`}>
      •	To provide you with access to the Website. 
    </p>
    <p className={` pl-3`}>
      •	To register you to use the Production Software.
    </p>
    <p className={` pl-3`}>
      To sell the Production Software.
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	Device Information
    </p>
    <p className={` pl-3`}>
      •	Registration Information
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Consent
    </p>
    <p className={` pl-3`}>
      To process your Personal Data contained in further production information 
      uploaded, we rely on your consent. You have the right to withdraw consent 
      to marketing by contacting us at any time.
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Provide Production Services
    </p>
    <p className={` pl-3`}>
      •	To enable use of the Production Software during the production to, 
      among other things, upload production information, schedule, script, 
      storyboard, plan, administer and budget.
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	Production Information
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Compliance with Legal Obligations
    </p>
    <p className={` pl-3`}>
      We may process your Personal Data where it is necessary to comply with 
      legal obligations to which we are subject.
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	To comply with our legal obligations.
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	Device Information
    </p>
    <p className={` pl-3`}>
      •	Registration Information
    </p>
    <p className={` pl-3`}>
      •	Production Information
    </p>
  </Col>
  </Row>
  <Row>
  <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={`${styles.ChartTL } pl-3`}>
     To Defend, Establish or be a Party to Legal Claims
    </p>
    <p className={` pl-3`}>
      We may process your Personal Data as necessary in order for us to establish, 
      investigate, exercise or defend a legal claim to which you are a party.
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	To investigate, establish, exercise or defend a legal claim.
    </p>
    </Col>
    <Col xs={4} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	Device Information
    </p>
    <p className={` pl-3`}>
      •	Registration Information
    </p>
    <p className={` pl-3`}>
      •	Production Information
    </p>
    </Col>
  </Row>
  </div>
  <h5 className="my-3">
   We may obtain the following Personal Data about you from other third parties:
  </h5>
  <div>
  <Row>
  <Col xs={3} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Registration Information of Administrative Users and Crew Users
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	In the event your data is collected by a User to register you as an 
      Administrative User or Crew User registration, basic information may be 
      shared with us including your name, email address, phone number and your 
      role in the production project. 
    </p>
    </Col>
  </Row>
  </div>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>
    3.	WHO WE SHARE YOUR PERSONAL DATA WITH
   </span>
  </h3>
  <h5 className="my-3">
   We will disclose your Personal Data to some or all of the following recipients:
  </h5>
  <div>
  <Row>
  <Col xs={12} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      RECIPIENTS
    </p>
  </Col>
  <Col xs={12} className={`${styles.ChartBor }`}>
    <p className={`${styles.BoldMargin } pl-3`}>
      AWS
    </p>
    <p className={` pl-3`}>
      Amazon Web Services, Inc. and/or its 
      affiliates (“<span className={`${styles.Bold} mb-0`}>AWS</span>”), for 
      the purposes of cloud hosting, storage [and for sending Users notification 
      emails through Amazon Web Services Simple Email 
      Service (“<span className={`${styles.Bold} mb-0`}>AWS SES</span>”)] 
    </p>
    <p className={`mt-3 pl-3`}>
      For information on how AWS processes your Personal Data, please see 
      the <a
          href="https://aws.amazon.com/privacy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          AWS Privacy Notice
        </a>
    </p>
  </Col>
  <Col xs={12} className={`${styles.ChartBor }`}>
    <p className={`${styles.BoldMargin } pl-3`}>
      Stripe
    </p>
    <p className={` pl-3`}>
      Stripe Payments Europe, Limited, and Stripe Technology Europe, 
      Limited (“<span className={`${styles.Bold} mb-0`}>Stripe</span>”), 
      for the purposes of payment processing.
    </p>
    <p className={`mt-3 pl-3`}>
      For information on how Stripe processes your Personal Data, 
      please see the <a
          href="https://stripe.com/ie/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Stripe Privacy Policy
        </a>.
    </p>
  </Col>
  <Col xs={12} className={`${styles.ChartBor }`}>
    <p className={`${styles.BoldMargin } pl-3`}>
      Cookie Policy Consent Management Provider
    </p>
    <p className={` pl-3`}>
      TERMLY INC (“<span className={`${styles.Bold} mb-0`}>TERMLY</span>”), 
      for the purposes of managing your Cookie Policy Consent
    </p>
    <p className={`mt-3 pl-3`}>
      For information on how TERMLY processes your Personal Data, 
      please click on the TERMLY button to view the Cookie Policy.
      {/* <a
          href="xxx"
          target="_blank"
          rel="noopener noreferrer"
        >
          TERMLY Cookie Policy 
        </a>. */}
    </p>
  </Col>
  <Col xs={12} className={`${styles.ChartBor }`}>
    <p className={`${styles.BoldMargin } pl-3`}>
      Other Recipients 
    </p>
    <p className={` pl-3`}>
      •	Regulatory authorities and law enforcement agencies (where 
      we are under a duty to disclose or share your Personal Data in order 
      to comply with any legal or regulatory obligation or request). 
    </p>
    <p className={` pl-3`}>
      •	To protect the rights, property or safety of FirstSlate, our customers, or others.  
    </p>
    <p className={` pl-3`}>
      •	External advisors e.g. lawyers, accountants and auditors (as necessary to protect FirstSlate’s legitimate and 
      legal interests in the performance of business/financial affairs).  
    </p>
    <p className={` pl-3`}>
      •	Service providers for logistical and IT service purposes, and to provide our customer service infrastructure. 
    </p>
    <p className={` pl-3`}>
      •	Third parties to whom we may choose to sell, transfer, or merge parts of 
      our business or our assets. Alternatively, we may seek to acquire other 
      businesses or merge with them. If a change happens to our business, then 
      the new owners may use your personal data in the same way as set out in 
      this privacy notice.  
    </p>
  </Col>
  </Row>
  </div>
  <h5 className="mt-3">
    We require all third parties to respect the security of your personal 
    data and to treat it in accordance with the law. We do not allow our third-party 
    service providers to use your personal data for their own purposes and only 
    permit them to process your personal data for specified purposes and in 
    accordance with our instructions.
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>
    4.	TRANSFERS OF YOUR PERSONAL DATA
   </span>
  </h3>
  <h5 className="mt-3">
   Your Personal Data may be stored and transferred outside the European Economic 
   Area ("<span className={`${styles.Bold} mb-0`}>EEA</span>"). We only transfer 
   your Personal Data outside the EEA where the EU Commission has decided that the 
   third country in question ensures an adequate level of protection in line with 
   EU data protection standards (i.e. that an adequacy decision has been granted 
   in the country's favour) or there are appropriate safeguards in place to protect 
   your Personal Data. 
  </h5>
  <h5 className="mt-3">
   For Transfers of personal data to AWS and Stripe, we rely on 
   compliance with the EU-U.S. Data Privacy Framework. 
  </h5>
  <h5 className="mt-3">
   If you would like to find out more about the appropriate safeguards that we 
   have in place to govern the transfer of your Personal Data you can 
   contact us using the contact information in Section 6 of this Policy. 
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>
    5.	HOW LONG WE KEEP YOUR PERSONAL DATA FOR 
   </span>
  </h3>
  <h5 className="mt-3">
   In general, we will keep your Personal Data for as long as is necessary for 
   the purposes for which it was obtained from the date of collection or, where 
   you enter into a contractual arrangement with us, following the end of the 
   performance of our contract (which may be up to 7 years in some cases). 
   Please note that in certain circumstances, we may hold your data for a longer 
   period, for example, if we are processing an ongoing claim or believe in good 
   faith that the law or a relevant regulator may reasonably in our view expect 
   or require us to preserve your Personal Data.
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>
    6.	YOUR RIGHTS AND HOW TO EXERCISE THEM 
   </span>
  </h3>
  <h5 className="my-3">
    You have a number of rights in relation to your Personal Data under the 
    Data Protection Laws as set out in the table below. In particular these 
    rights include the right to object to processing of your Personal Data 
    where that processing is carried out for our legitimate 
    interests. <span className={`${styles.Bold} mb-0`}>Note that in certain 
      circumstances these rights might not be absolute.</span>
  </h5>
  <div>
  <Row>
  <Col xs={3} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Right
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBorBack }`}>
    <p className={` pl-3`}>
      Further Information 
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={3} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Right of Access
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	You have the right to request a copy of the Personal Data held by us 
      about you and to access the following information in relation to the 
      processing of your Personal Data:
    </p>
    <p className={`mt-3 pl-3`}>
      1.	the purposes of processing;
    </p>
    <p className={`pl-3`}>
      2.	the categories of Personal Data concerned;
    </p>
    <p className={`pl-3`}>
      3.	the recipients of your Personal Data;
    </p>
    <p className={`pl-3`}>
      4.	the period for which your Personal Data will be stored;
    </p>
    <p className={`pl-3`}>
      5.	the existence of your right to lodge a 
      complaint with the Data Protection Commission; and
    </p>
    <p className={`pl-3`}>
      6.	the source of your Personal Data.
    </p>
    <p className={`mt-3 pl-3`}>
      We will only charge you for making such an access 
      request in certain circumstances as permitted under the Data Protection Laws.
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={3} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Right to Rectification
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	You have the right to have any inaccurate
       Personal Data which we hold about you updated or corrected. 
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={3} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Right to Erasure
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	You have the right to ask us to erase your Personal Data where:
    </p>
    <p className={`mt-3 pl-3`}>
      1. it is no longer necessary to perform the contract; 
    </p>
    <p className={`pl-3`}>
      2.	you withdraw your consent and there is no other 
      legal basis permitting us to process your Personal Data; 
    </p>
    <p className={`pl-3`}>
      3.	you object to the processing and we have no overriding legitimate grounds; 
    </p>
    <p className={`pl-3`}>
      4.	your Personal Data has been unlawfully processed; or
    </p>
    <p className={`pl-3`}>
      5.	erasure is required to comply with a legal obligation.
    </p>
    <p className={`mt-3 pl-3`}>
      Please note that some of your Personal Data may be required 
      in order for the Website to function properly. 
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={3} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Right to Restriction of Processing
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	You have the right to ask us to restrict processing your 
      Personal Data in the following situations:
    </p>
    <p className={`mt-3 pl-3`}>
      1. where you contest the accuracy of your Personal Data;
    </p>
    <p className={`pl-3`}>
      2.	where the processing is unlawful 
      and you do not want us to delete your Personal Data;  
    </p>
    <p className={`pl-3`}>
      3.	where we no longer need your Personal Data for the 
      purposes of processing but you require the data in relation to a legal claim; or
    </p>
    <p className={`pl-3`}>
      4.	where you have objected to us processing your Personal Data pending 
      verification as to whether or not our legitimate interests override your 
      interests or in connection with legal proceedings. 
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={3} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Right to Data Portability
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	You have the right to receive any Personal Data in a structured, 
      commonly used and machine-readable format and you may request us to 
      transmit your Personal Data directly to another data controller where 
      this is technically feasible. 
    </p>
    <p className={`mt-3 pl-3`}>
      •	This right only arises where we process your Personal Data on the legal 
      bases of your consent or where it is necessary to perform our contract with you.
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={3} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Right to Object
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	You have a right to object at any time to the processing of your 
      Personal Data where we process your Personal Data on the legal basis of 
      pursuing our legitimate interests. 
    </p>
    </Col>
  </Row>
  <Row>
  <Col xs={3} className={`${styles.ChartBorBack }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Right to Withdraw Consent
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      •	This right only exists where the basis relied on is 
      consent. You may withdraw consent at any time.
    </p>
    </Col>
  </Row>
  <h5 className="mt-5">
   You can exercise any of these rights by submitting a request to: 
  </h5>
  <Row className="mt-3" >
  <Col xs={3} className={`${styles.ChartBor }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Contact:
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      FirstSlate Limited
    </p>
    </Col>
  </Row>
  <Row >
  <Col xs={3} className={`${styles.ChartBor }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Email:
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      info@firstslate.net
    </p>
    </Col>
  </Row>
  <Row className="mt-3" >
  <Col xs={3} className={`${styles.ChartBor }`}>
    <p className={`${styles.ChartTL } pl-3`}>
      Post:
    </p>
    </Col>
    <Col xs={9} className={`${styles.ChartBor }`}>
    <p className={` pl-3`}>
      FirstSlate Limited
    </p>
    <p className={` pl-3`}>
      5 Monkton Row, 
    </p>
    <p className={` pl-3`}>
      Wicklow A67VK02
    </p>
    <p className={` pl-3`}>
      Ireland
    </p>
    </Col>
  </Row>
  </div>
  <h5 className="mt-3">
   We will provide you with information on any action taken upon your request 
   in relation to any of these rights without undue delay within 1 month of 
   receiving your request. We may extend this up to 2 months if necessary however 
   we will inform you if this arises. Please note that we may ask you to verify 
   your identity when you seek to exercise any of your data protection rights.
  </h5>
  <h5 className="mt-3">
   You also have the right to lodge a complaint with the DPC by emailing info@dataprotection.ie. 
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>
    7.	DATA SECURITY
   </span>
  </h3>
  <h5 className="mt-3">
   We have put in place appropriate security measures to prevent your personal 
   data from being accidentally lost, used or accessed in an unauthorised way, 
   altered or disclosed. In addition, we limit access to your personal data to 
   those employees, agents, contractors and other third parties who have a 
   business need to know. They will only process your personal data on our 
   instructions and they are subject to a duty of confidentiality. 
  </h5>
  <h5 className="mt-3">
   We have put in place procedures to deal with any suspected personal data 
   breach and will notify you and any applicable regulator of a breach where we are 
   legally required to do so.
  </h5>
  <h3 className="mt-5">
   <span className={`${styles.Bold} mb-0`}>
    8.	CHANGES TO THIS POLICY & QUESTIONS 
   </span>
  </h3>
  <h5 className="mt-3">
   This Policy will be regularly reviewed and 
   may be amended and updated from time to time as necessary.
  </h5>
  <h5 className="mt-3">
   If you have any questions, comments or concerns about the way your 
   Personal Data are being used or processed by FirstSlate, please submit your 
   question, comment or concern in writing using the contact information 
   in Section 6 of this Policy.
  </h5>
  </Col>
  </Row>
  </div>
  </>;
}